import { Link } from 'react-router-dom';
import { Fragment } from 'react';

export type Crumb = {
  label: string;
  to?: string;
};

export function Breadcrumbs({ crumbs }: { crumbs: Crumb[] }) {
  if (crumbs.length === 0) return null;
  return (
    <nav className="breadcrumbs" aria-label="breadcrumb">
      {crumbs.map((c, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <Fragment key={`${c.label}-${i}`}>
            {c.to && !isLast ? (
              <Link to={c.to} className="breadcrumb-link">
                {c.label}
              </Link>
            ) : (
              <span className="breadcrumb-current">{c.label}</span>
            )}
            {!isLast && (
              <span className="breadcrumb-sep" aria-hidden>
                ›
              </span>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
